export class Mascara {
  aplicarMascaraNumerica(valor: any): string {
    let novoValor = '';

    for (let i = 0; i < valor.length; i++) {
      const aux = valor[i].replace(/^[^[0-9]]*$/, '');
      novoValor += aux;
    }

    return novoValor;
  }

  aplicarMascara(valor: any, regex: any) {
    let novoValor = '';

    for (let i = 0; i < valor.length; i++) {
      const aux = valor[i].replace(regex, '');
      novoValor += aux;
    }

    return novoValor;
  }
}
